<template>
  <div>
    <div v-if="type === 'table'">
      <SkeletonTable
        :row="row"
        :column="column"
        :size-table="sizeTable"
        :show-image-column="showImageColumn"
        :avatar-column-index="avatarColumnIndex"
        :avatar="avatar"
        class="h-full overflow-y-auto"
      ></SkeletonTable>
    </div>
  </div>
</template>

<script>
import SkeletonTable from "@/components/skeleton/SkeletonTable.vue";

export default {
  name: "SkeletonView",
  components: { SkeletonTable },
  props: {
    column: {
      type: Number,
      default: 15,
    },
    row: {
      type: Number,
      default: 6,
    },
    type: {
      type: String,
      default: "table",
    },
    sizeTable: {
      type: String,
      default: "small",
    },
    count: {
      type: Number,
      default: 5,
    },
    showImageColumn: {
      type: Boolean,
      default: true,
    },
    avatarColumnIndex: {
      type: Number,
      default: 0,
    },
    avatar: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped></style>
